import { render, staticRenderFns } from "./relacion.vue?vue&type=template&id=40dc7b3e"
import script from "./relacion.vue?vue&type=script&lang=js"
export * from "./relacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports